import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import "./LoginPage.css";
// import { loginUser } from "../../services/auth/AuthAPI";
import { Form, Spin } from "antd";
import TranscribeLogo from "../../../assets/img/logo.png";
import WilliamColorLogo from "../../../assets/img/williams_lea.png";
import { loginUser } from "../../../services/auth/AuthAPI";
import APP_CONFIG from "../../../configs/environment";

function LoginPage(props: any) {
  const [loading, setLoading] = useState(false);
  const [nativeLoginForm] = Form.useForm();
  const [ssoLoginForm] = Form.useForm();
  const [error, setError] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    localStorage.clear();
  }, []);
  const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  const nativeLogin = async (values: any) => {
    try {
      setLoading(true);
      await loginUser(values.username, values.password);
      setLoading(false);
      navigate("/auth");
    } catch (error: any) {
      setError(error.message);
      setLoading(false);
    }
  };

  const federatedLogin = async (values: any) => {
    //Getting domain of email
    const domain = values.email.split("@")[1];
    const constructAuthUrl = "https://" + APP_CONFIG.amplify_config.oauth.domain + "/" + "authorize?idp_identifier=" + domain + "&redirect_uri=" + APP_CONFIG.amplify_config.oauth.redirectSignIn + "&response_type=" + APP_CONFIG.amplify_config.oauth.responseType + "&client_id=" + APP_CONFIG.amplify_config.Auth.userPoolWebClientId + "&scope=email%20openid%20profile";
    window.location.href = constructAuthUrl;
  };

  return (
    <div className="login-main-container container-fluid justify-content-center align-item-center overflow-auto">
      <Spin spinning={loading}>
        <div className="login-container">
          <div className="login-wrapper">
            <img
              className="mb-3"
              src={TranscribeLogo}
              alt="Transcribe"
            />
            <Form
              {...formItemLayout}
              onFinish={(values) => {
                nativeLogin(values);
              }}
              colon={false}
              form={nativeLoginForm}
              style={{ width: "100%" }}>
              <Form.Item
                label="Email"
                name={"username"}
                required={false}
                rules={[{ required: true, message: "Please input your username!" }]}
                labelAlign="left">
                <input
                  type="text"
                  className="form-control"
                />
              </Form.Item>
              <Form.Item
                label="Password"
                name={"password"}
                required={false}
                rules={[{ required: true, message: "Please input your password!" }]}
                labelAlign="left">
                <input
                  type="password"
                  className="form-control"
                />
              </Form.Item>
            </Form>

            <div className="d-flex flex-column w-100 ">
              <span
                className="mb-3"
                style={{ color: "red", width: "100%" }}>
                {error}
              </span>
              <button
                className="button"
                style={{ justifySelf: "center", alignSelf: "center" }}
                onClick={() => nativeLoginForm.submit()}>
                Login
              </button>
            </div>
            <div
              className="link my-3"
              onClick={() => navigate("forgot-password")}>
              Forgot your password?
            </div>

            <div className="d-flex w-100 gap-1 align-items-center">
              <hr className="w-100" />
              Or
              <hr className="w-100" />
            </div>
            <Form
              {...formItemLayout}
              onFinish={async (values) => {
                federatedLogin(values);
              }}
              colon={false}
              form={ssoLoginForm}
              style={{ width: "100%" }}>
              <Form.Item
                label="Email"
                name={"email"}
                required={false}
                rules={[
                  {
                    validator: async (_, value) => {
                      if (!value) {
                        return Promise.reject("Email is required");
                      }
                      const domain = value.split("@")[1];
                      const allowedDomains = APP_CONFIG.appSettingsData.allowedDomain;
                      const isDomainAllow = allowedDomains.includes(domain);
                      if (!isDomainAllow) {
                        return Promise.reject("Tenant is not configured for SSO");
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
                labelAlign="left">
                <input
                  type="text"
                  className="form-control"
                />
              </Form.Item>
            </Form>
            <div className="d-flex flex-column w-100">
              <button
                className="button"
                style={{ justifySelf: "center", alignSelf: "center" }}
                onClick={() => ssoLoginForm.submit()}>
                Login with SSO
              </button>
            </div>
            <img
              className="mt-3"
              src={WilliamColorLogo}
              alt="Williams Lea"
            />
          </div>
        </div>
      </Spin>
    </div>
  );
}

export default LoginPage;
